import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiUserTypeComponent } from './multi-user-type.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MultiUserTypeComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  exports: [MultiUserTypeComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],
})
export class MultiUserTypeModule {}
